import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';

export const getClientName = (client: AdminClientProfileViewModel) => (
  <>
    {client.name ?? ''}&nbsp;{client.surname ?? ''}
  </>
);
